import {
   OKTA_EXTERNAL_CONFIG,
   OKTA_INTERNAL_CONFIG,
 } from "./utils/appConstant";

const externalConfig = OKTA_EXTERNAL_CONFIG;

const internalConfig = OKTA_INTERNAL_CONFIG;

export { externalConfig, internalConfig };
